import { marketCloseHour, marketCloseMinute } from './constants.js';
import dayjs from 'dayjs';
export const getMarketCloseUnix = (timestamp) => {
    return dayjs.unix(timestamp).hour(marketCloseHour).minute(marketCloseMinute).unix();
};
//# sourceMappingURL=getMarketCloseUnix.js.map